import * as React from "react";
import { styled } from "@mui/material";
import { PatientPopup } from "../components/uiControllers/patientPopup";
import { GenericButton } from "../components/uiControllers/genericButton";
import { useState } from "react";
import { useTranslate } from "../hooks/useTranslate";

//region [[ Styles ]]

const AlertPopupView = styled(PatientPopup)({
  "& .patient-popup-container": {
    position: "absolute",
    left: "5%",
    width: "90%",
    maxWidth: "600px",
    padding: "35px",
    margin: "50px 0",
  },
  "& .close-button": {
    right: 0,
  },
});

const PopupContent = styled("div")({
  fontSize: "18px",
  marginTop: "20px",
  marginBottom: "20px",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface AlertPopupProps {
  children?: any;
  onClose?: () => void;
  enableClose?: boolean;
}

export interface SimpleAlertPopupProps extends AlertPopupProps {
  textId: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const AlertPopup = ({ ...props }: AlertPopupProps) => {
  const { onClose, children, enableClose } = props;
  const [showAlert, setShowAlert] = useState<boolean>(true);
  return (
    <AlertPopupView open={showAlert}>
      <PopupContent>{children}</PopupContent>
      {enableClose && (
        <GenericButton
          onClick={() => {
            setShowAlert(false);
            onClose && onClose();
          }}
          label="Close"
        />
      )}
    </AlertPopupView>
  );
};

export const TextAlertPopUpWithTranslate = ({
  ...props
}: SimpleAlertPopupProps) => {
  const { translate } = useTranslate();
  return <AlertPopup {...props}>{translate(props.textId)}</AlertPopup>;
};
